var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldShowBanner)?_c('Banner',{attrs:{"color-scheme":"alert","banner-message":_vm.bannerMessage,"action-button-label":_vm.$t('GENERAL_SETTINGS.AI_CREDITS_EXHAUSTED.DONT_SHOW_AGAIN'),"action-button-variant":"smooth","has-action-button":"","has-close-button":""},on:{"click":_vm.dismissPermanently,"close":_vm.dismissCurrentSession}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }